import { TTopCategory, TCategory } from '../data';
import { findTopCategoryData } from './find-data-helpers';

//	функция для получения количества доступных для рендера рядов
export const getNumberOfRenderedCategoriesRows = (
	topCategory: TTopCategory,
	numberOfShownRows: number,
	numberOfCardsInARow: number,
	numberOfRenderedRows: number
): number => {
	//	определяем количество доступных рядов
	const numberOfAvailableRows =
		numberOfShownRows > numberOfRenderedRows ? numberOfShownRows - numberOfRenderedRows : 0;

	let numberOfNewRenderedRows = 0;

	// если есть доступные ряды, определяем, сколько можем отрендерить
	if (numberOfAvailableRows) {
		//	определяем, сколько рядов в категории
		const numberOfCategoryRows = getNumberOfCategoryRows(
			topCategory.categories,
			numberOfCardsInARow
		);

		//	определяем, сколько можем отрендерить
		numberOfNewRenderedRows =
			numberOfCategoryRows > numberOfAvailableRows
				? numberOfAvailableRows
				: numberOfCategoryRows;
	}

	return numberOfNewRenderedRows;
};

export const getNumberOfCategoryRows = (
	categories: TCategory[],
	numberOfCardsInARow: number
): number => {
	const numberOfCategories = categories.length;
	return Math.ceil(numberOfCategories / numberOfCardsInARow);
};

export const countNumberOfAllRows = (
	selectedFilterItems: number[],
	topCategories: TTopCategory[],
	numberOfCardsInARow: number
): number => {
	let numberOfAllRows = 0;

	if (selectedFilterItems.length === 0) {
		topCategories.forEach(({ categories }) => {
			numberOfAllRows += getNumberOfCategoryRows(categories, numberOfCardsInARow);
		});
	} else {
		selectedFilterItems.forEach(topCategoryId => {
			const { categories } = findTopCategoryData(topCategories, topCategoryId);
			numberOfAllRows += getNumberOfCategoryRows(categories, numberOfCardsInARow);
		});
	}
	return numberOfAllRows;
};
